

export class Beeper
{
    public readonly Name: string;
    public Frequency: number;
    public Duration: number;
    private readonly ctx: AudioContext;
    private osc: OscillatorNode | null;

    constructor(name: string, frequency: number, durationInSeconds: number = 0)
    {
        this.Name = name;
        this.Frequency = frequency;
        this.Duration = durationInSeconds;

        this.ctx = new (window.AudioContext || window.webkitAudioContext)();
        this.osc = null;
    }

    public Play()
    {
        if (this.osc) return;
        this.osc = this.ctx.createOscillator();
        this.osc.type = 'sine';
        this.osc.frequency.value = this.Frequency;
        this.osc.connect(this.ctx.destination);
        this.osc.start(this.ctx.currentTime);
        if (this.Duration > 0)
        {
            this.osc.stop(this.ctx.currentTime + this.Duration);
            this.osc.onended = () =>
            {
                this.osc?.disconnect?.();
                this.osc = null;
            }
        }
    }

    public Stop()
    {
        if (!this.osc) return;
        this.osc.stop();
        this.osc.disconnect();
        this.osc = null;
    }

    public PlayTones(tones: { freq: number, volume?: number, duration: number }[])
    {
        let currentTime = this.ctx.currentTime;

        tones.forEach(t =>
        {
            const osc = this.ctx.createOscillator();
            const gain = this.ctx.createGain();

            osc.frequency.value = t.freq;
            gain.gain.setValueAtTime(0.0001, currentTime);
            gain.gain.linearRampToValueAtTime(t.volume ?? 0.2, currentTime + 0.01);
            gain.gain.linearRampToValueAtTime(0.0001, currentTime + t.duration);

            osc.connect(gain).connect(this.ctx.destination);

            osc.start(currentTime);
            osc.stop(currentTime + t.duration);

            currentTime += t.duration;
        });
    }
}
